<div class="spinner" [ngStyle]="{ 'width': size, 'height': size, 'border-width': borderWidth}"></div>
